import RUN_HISTORY_DATE_FILTER_OPTIONS from '@/lib/automations/RUN_HISTORY_DATE_FILTER_OPTIONS.js';

export const DEFAULT_RUN_HISTORY_DATE_FILTER = 'today';

const resolveSelectedRunHistoryDateFilter = (value) => {
  if (RUN_HISTORY_DATE_FILTER_OPTIONS.some((option) => option.value === value)) {
    return value;
  }

  return DEFAULT_RUN_HISTORY_DATE_FILTER;
};

export default resolveSelectedRunHistoryDateFilter;
